import React from 'react';
import _ from 'lodash';

import './styles.css';

interface BookingProps {
  booking: any;
}

class OtherBookingMembers extends React.Component<BookingProps> {
  render() {
    const {booking} = this.props;

    let otherMembersCount = 0;
    if (_.get(booking, 'secondaryTenant.fullName')) {
      otherMembersCount += 1;
    }
    if (_.get(booking, 'guarantor.fullName')) {
      otherMembersCount += 1;
    }

    return otherMembersCount ? (
      <div className="OtherBookingMembers colab-bold">
        + {otherMembersCount} more
      </div>
    ) : null;
  }
}

export default OtherBookingMembers;
